import React, { useEffect, useState } from "react";
import authApiService from "../services/authServices";
import { Link } from "react-router-dom";
import Modal from "../utils/modalUtils";
import FooterLogo from "../components/FooterLogo";
import { Oval } from 'react-loader-spinner';


function Feedback() {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [feedBack, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);



  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstName || !lastName || !email || !phoneNumber || !feedBack) {
      Modal.fire({
        icon: "warning",
        title: "Incomplete Form",
        text: "Please fill in all fields before submitting.",
        confirmButtonText: "OK"
      });
      return;
    }
    if (!emailRegex.test(email)) {
      Modal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
        confirmButtonColor: "#dc3545",
      });
      return;
    }
    setLoading(true);
    const payload = {
      feedBack,
      firstName,
      lastName,
      email,
      phoneData: phoneNumber,
    };

    try {
      const response = await authApiService.post("sendFeedback", payload);
      if (response?.code === 200) {
        Modal.fire({
          icon: "success",
          title: "Feedback Sent!",
          text: "Thank you for your feedback.",
          confirmButtonColor: "#28a745",
        });
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhoneNumber('');
        setFeedback('');
      } else {
        throw new Error(response?.message || "Feedback submission failed");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      Modal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          error.response?.data?.message ||
          error.message ||
          "There was a problem submitting your feedback.",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.5)', // semi-transparent white background
          zIndex: 9999,
        }}
      >
        <Oval
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }

  return (
    <>
      <div className="page-container col-sm-9 clearfix">
        <div id="feedback-header">
          <div id="header-feedback-text">
            <span className="count-down">Feedback Open Play Tennis</span>
          </div>
        </div>
        <div className="row d-flex align-self-stretch mt-4">
          <div className="col-lg-6 item-self-stretch mb-4">
            <div className="shadow-sm feedback-grey-box p-5 h-100 msg-body-container">
              <p>Questions related to a match or tournament</p>
              <p>Technical support or enhancements / suggestions</p>
              <p>Request a new city</p>
              <p className="mb-0">General information</p>
            </div>
          </div>
          <div className="col-lg-6 align-self-stretch mb-4">
            <div className="shadow-sm feedback-green-box greenboxMobile p-5 h-100" style={{ color: 'black' }}>
              <p>Info@openplaytennis.com</p>
              <p>Info@openplaytennis.com</p>
              <p>Info@openplaytennis.com</p>
              <p className="mb-0">Tchair@openplaytennis.com</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 align-self-stretch mb-4">
            <div className="rules-box-container h-100 mt-0">
              <div className="d-flex heading-golfer justify-content-between"
              style={{ width: 'calc(100% - 30px)', marginLeft: '30px' }}>
                <h3 className="text-light mb-0 font-weight-bold pt-1">Send Us Your Feedback</h3>
                <a href="#">
                  <img src="/images/public-edit-icon.png" alt="Edit" />
                </a>
              </div>
              <div className="msg-body-container rule-head shadow-sm">
                <div className="rule-subsection send-feedback-container pl-3">
                  <div className="form-group row">
                    <label for="firstname" className="col-sm-5 col-form-label">First Name:</label>
                    <div class="col-sm-7">
                      <input
                        type="text"
                        placeholder="Sara"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        className="form-control border-0 bg-transparent form-control-sm border-bottom bdr-cdark rounded-0 textarea_green"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label for="staticEmail" className="col-sm-5 col-form-label">Last Name:</label>
                    <div class="col-sm-7">
                      <input
                        type="text"
                        placeholder="Guzman"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        className="form-control border-0 bg-transparent form-control-sm border-bottom bdr-cdark rounded-0 textarea_green"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label for="staticEmail" className="col-sm-5 col-form-label">Email:</label>
                    <div class="col-sm-7">
                      <input
                        type="email"
                        placeholder="Sarag@gmail.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        maxLength={50}
                        className="form-control border-0 bg-transparent form-control-sm border-bottom bdr-cdark rounded-0 textarea_green"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="staticEmail" className="col-sm-5 col-form-label ">Phone Number:</label>
                    <div class="col-sm-7">
                      <input
                        className="form-control border-0 bg-transparent form-control-sm border-bottom bdr-cdark rounded-0 textarea_green"
                        type="text"
                        // placeholder="(XXX) xxx xxxx"
                        placeholder="503 475 9141"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedData = e.clipboardData.getData('Text');
                          if (!/^\d+$/.test(pastedData)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={10}
                        required
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-stretch mb-4">
            <div className="msginput-container grey-box h-100 pb-0">
              <label htmlFor="msginput">Feedback:</label>
              <textarea
                id="msginput"
                name="message"
                rows={14}
                className="emailMessage textarea_green"
                value={feedBack}
                onChange={(e) => setFeedback(e.target.value)}
                required
                placeholder={`Please provide your feedback, comments, questions or anything else you would like answered here….`}
              />
            </div>

          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-end mt-4 px-3">
              <div className="mb-0">
                <div className="buttonwrapper">
                  <Link to="#" className="gray_btn mr-2">
                    <span style={{ width: 52 }}>Cancel</span>
                  </Link>
                </div>
              </div>
              <div className="search-col mb-0">
                <div className="buttonwrapper">
                  <button
                    className="green_btn"
                    onClick={handleSubmit}
                  >
                    <span style={{ width: 52 }}>Send</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer_space'></div>
      <FooterLogo />
    </>

  )
}

export default Feedback